module.exports = __webpack_public_path__ + "static/img/002.e73cd2f9.png";